import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import { LeadSubSourceService } from './lead-sub-source.service';
import { BehaviorSubject, Subject } from 'rxjs';
@Component({
  selector: 'app-lead-sub-source',
  templateUrl: './lead-sub-source.component.html',
  styleUrls: ['./lead-sub-source.component.scss']
})
export class LeadSubSourceComponent implements OnInit {
  displayedColumns: string[] = ['SNo', 'lead_sub_source', 'code', 'lead_source', 'status', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);

  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  leadSubSourceForm: FormGroup;
  public searchInput = new FormControl("");
  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private leadSubSourceService: LeadSubSourceService) {
    this.leadSubSourceForm = this.fb.group({
      subsource: ['', Validators.required],
      code: ['', Validators.required],
      source: ['', Validators.required],
      status: ['', Validators.required]
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;
  isLoading: Subject<boolean> = new Subject<boolean>();

  ngOnInit() {
    this.getList();
    this.getAllSource();
    this.searchInput.valueChanges.subscribe(() => {
      this.applyFilter();
    });
  }

  get f() { return this.leadSubSourceForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    this.leadSubSourceForm.patchValue({
      subsource: object.lead_sub_source,
      source: object.lead_source_id,
      code: object.code,
      status: object.status ? 1 : 0
    })
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }

  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
  
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const lead_sub_source = data.lead_sub_source.toLowerCase().includes(filter);
      const code = data.code.toLowerCase().includes(filter);
      return lead_sub_source || code;
    };
      this.dataSource.filter = filterValue;
  }

  clearSearch() {
    this.searchInput.setValue('');
    this.applyFilter();
  }

  create() {
    this.submitted = true
    if (this.leadSubSourceForm.valid) {
      const sourceData = this.leadSubSourceForm.value;
      let obj = {
        "lead_sub_source": sourceData.subsource,
        "lead_source_id": sourceData.source,
        "code": sourceData.code,
        "status": parseInt(sourceData.status),
        "flag": "create"
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.leadSubSourceService.subSourceCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Lead sub source created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    if (this.leadSubSourceForm.valid) {
      const sourceData = this.leadSubSourceForm.value;
      let obj = {
        "lead_sub_source": sourceData.subsource,
        "lead_source_id": sourceData.source,
        "code": sourceData.code,
        "status": parseInt(sourceData.status),
        "flag": "update",
        "id": this.selectedObject.id
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.leadSubSourceService.subSourceCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Lead sub source updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.leadSubSourceForm.patchValue({
      source: '',
      code:'',
      status: '',
      subsource: ''
    });
  }

  allowAplhabetsOnly(event: any) {
    this.sharedService.allowAlphabetsOnly(event);
  }

  getList() {
    let reqObject = {
      flag: 'list'
    }
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.leadSubSourceService.subSourceCrud(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  public sourceList: any = [];
  getAllSource() {
    let reqObject = {
      flag: 'list'
    }
    this.leadSubSourceService.sourceList(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.sourceList = responseData.data
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }
}
